import React from 'react';
import './DesktopLayout.css';
import DesktopLeft from './DesktopLeft';
import DesktopRight from './DesktopRight';
import background2 from '../assets/网站设计/PC端切图/background2.webp';

const DesktopLayout: React.FC = () => {
  return (
    <div
      className="desktop-layout"
      style={{
        backgroundImage: `url(${background2})`
      }}
    >
      <DesktopLeft />
      <DesktopRight />
    </div>
  );
};

export default DesktopLayout;